import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mapToIterable' })
export class MapToIterablePipe implements PipeTransform {
  transform(dict: Object): Array<any> {
    if (dict) {
      return Object.keys(dict).map(key => dict[key]);
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/pipes/map-to-iterable.pipe.ts